import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { TranslationsHandlerService } from '../../core/translations/services/translations-handler.service';
import { UserSettingsService } from '../../core/user-settings/services/user-settings.service';

export const TranslationsResolver: ResolveFn<Object> =
  async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Object> => {

    const translationsHandlerService = inject(TranslationsHandlerService);
    const userSettingsService = inject(UserSettingsService);
    await userSettingsService.get();
    return translationsHandlerService.setTranslation(userSettingsService.getPreferences().language);
  };
